var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAhkSmallIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.55098 8.41529L1.59961 10.1604H2.47078C2.47078 10.1604 3.60745 8.67456 3.6842 8.6075L6.68836 8.97809C6.68836 8.97809 7.8271 9.08664 7.51251 9.71098L5.00271 14.7368H5.76879L10.6231 8.87507C10.6231 8.87507 11.3076 8.90065 12.2798 8.87507C13.2519 8.84949 14.3996 8.6393 14.3996 8.16845C14.3996 7.69761 13.2519 7.48811 12.2798 7.46253C11.3076 7.43626 10.6231 7.46253 10.6231 7.46253L5.76879 1.6001H5.00271L7.51251 6.62662C7.8271 7.25027 6.68836 7.35951 6.68836 7.35951L3.6842 7.72941C3.60745 7.66304 2.47078 6.17651 2.47078 6.17651H1.59961L2.55098 7.92162C2.11402 8.02188 1.91212 8.08687 1.91212 8.16845C1.91212 8.25073 2.11402 8.31503 2.55098 8.41529Z",
    fill: "#4C4C4C",
    fillOpacity: 0.6
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAhkSmallIcon);
export default __webpack_public_path__ + "static/media/ahk_small_icon.403efa405604edd30cc4c047fc4e453d.svg";
export { ForwardRef as ReactComponent };